import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import {
  clearActiveAlertEventsSlice,
  fetchAlertEventListNextPage,
  selectAlertEventsError,
  selectAlertEventsLoading,
  selectPagedAlertEventList,
  selectSelectedAlertEventsHasNextPage,
  selectTotalNumRecords,
} from '../../../redux/slices/selectedAlertEventsSlice/selectedAlertEventsSlice';
import HistoryListItem from './HistoryListItem/HistoryListItem';
import HistoryListItemSkeleton from './HistoryListItem/HistoryListItemSkeleton';
import { selectDeviceListInitialLoading } from '../../../redux/slices/deviceList/deviceListSlice';

/* istanbul ignore next */
const InfiniteScrollAlertHistory = () => {
  const dispatch = useDispatch();
  const bottomBoundaryRef = useRef(null);
  const loading = useSelector(selectAlertEventsLoading);
  const pagedAlertEventList = useSelector(selectPagedAlertEventList);
  const totalPages = useSelector(selectTotalNumRecords);
  const hasNextPage = useSelector(selectSelectedAlertEventsHasNextPage);
  const deviceLoading = useSelector(selectDeviceListInitialLoading);
  const loadingError = useSelector(selectAlertEventsError);

  useEffect(() => {
    const scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.intersectionRatio > 0 && hasNextPage) {
            dispatch(fetchAlertEventListNextPage());
          }
        });
      },
    );
    const target = bottomBoundaryRef.current;
    scrollObserver.observe(target);
    return () => {
      if (target) {
        scrollObserver.unobserve(target);
      }
    };
  }, [bottomBoundaryRef, hasNextPage, dispatch]);

  useEffect(() => {
    if (pagedAlertEventList.length === 0) {
      dispatch(fetchAlertEventListNextPage());
    }
    return () => {
      dispatch(clearActiveAlertEventsSlice());
    };
  }, []);

  return (
    <div>
      {loadingError && (
        <ErrorBanner>There was an unexpected error loading your data.</ErrorBanner>)}
      {!deviceLoading && pagedAlertEventList.map((alertEvent, index) => (
        <HistoryListItem
          index={index}
          alertEvent={alertEvent}
        />
      ))}
      {(deviceLoading || loading) && (
      <div>
        {Array.from({ length: 10 }).map((_, i) => (
          <HistoryListItemSkeleton key={i} index={i} />
        ))}
      </div>
      )}
      <div id="page-bottom-boundary" ref={bottomBoundaryRef} />
      {/* Placeholder for remaining empty space */}
      <div
        style={{ height: `${(totalPages - pagedAlertEventList.length) * 200}px` }} // Assuming height of each post is 200px
        className="placeholder"
      />
    </div>
  );
};

export default InfiniteScrollAlertHistory;
